import { addDays, isPlainDate } from './dates.js';
const MONTHS = {
    январь: 1,
    января: 1,
    янв: 1,
    january: 1,
    jan: 1,
    февраль: 2,
    февраля: 2,
    фев: 2,
    february: 2,
    feb: 2,
    март: 3,
    марта: 3,
    мар: 3,
    march: 3,
    mar: 3,
    апрель: 4,
    апреля: 4,
    апр: 4,
    april: 4,
    apr: 4,
    май: 5,
    мая: 5,
    may: 5,
    июнь: 6,
    июня: 6,
    июн: 6,
    june: 6,
    jun: 6,
    июль: 7,
    июля: 7,
    июл: 7,
    july: 7,
    jul: 7,
    август: 8,
    августа: 8,
    авг: 8,
    august: 8,
    aug: 8,
    сентябрь: 9,
    сентября: 9,
    сен: 9,
    сент: 9,
    september: 9,
    sep: 9,
    sept: 9,
    октябрь: 10,
    октября: 10,
    окт: 10,
    october: 10,
    oct: 10,
    ноябрь: 11,
    ноября: 11,
    ноя: 11,
    november: 11,
    nov: 11,
    декабрь: 12,
    декабря: 12,
    дек: 12,
    december: 12,
    dec: 12,
};
/** 0 — воскресенье, как в Date.getUTCDay(). */
const WEEKDAYS = {
    вс: 0,
    воскресенье: 0,
    sun: 0,
    sunday: 0,
    пн: 1,
    понедельник: 1,
    mon: 1,
    monday: 1,
    вт: 2,
    вторник: 2,
    tue: 2,
    tuesday: 2,
    ср: 3,
    среда: 3,
    среду: 3,
    wed: 3,
    wednesday: 3,
    чт: 4,
    четверг: 4,
    thu: 4,
    thursday: 4,
    пт: 5,
    пятница: 5,
    пятницу: 5,
    fri: 5,
    friday: 5,
    сб: 6,
    суббота: 6,
    субботу: 6,
    sat: 6,
    saturday: 6,
};
const RELATIVE = {
    сегодня: 0,
    today: 0,
    завтра: 1,
    tomorrow: 1,
    tmrw: 1,
    послезавтра: 2,
};
const DUE_PREFIX = '(?:до|by|deadline|срок)\\s+';
const MONTH_NAMES = Object.keys(MONTHS).join('|');
const WEEKDAY_NAMES = Object.keys(WEEKDAYS).join('|');
const RELATIVE_NAMES = Object.keys(RELATIVE).join('|');
/** Границы слова, работающие с кириллицей: \b на неё не рассчитан. */
const L = '(?<![\\p{L}\\p{N}])';
const R = '(?![\\p{L}\\p{N}])';
const DATE_RULES = [
    {
        re: new RegExp(`${L}(\\d{4}-\\d{2}-\\d{2})${R}`, 'u'),
        resolve: (m) => (isPlainDate(m[1]) ? m[1] : null),
    },
    {
        re: new RegExp(`${L}(${RELATIVE_NAMES})${R}`, 'iu'),
        resolve: (m, today) => addDays(today, RELATIVE[m[1].toLowerCase()]),
    },
    {
        re: new RegExp(`${L}(?:в|во|on)\\s+(${WEEKDAY_NAMES})${R}`, 'iu'),
        resolve: (m, today) => nextWeekday(today, WEEKDAYS[m[1].toLowerCase()]),
    },
    {
        re: new RegExp(`${L}(\\d{1,2})\\s+(${MONTH_NAMES})${R}`, 'iu'),
        resolve: (m, today) => fromDayMonth(Number(m[1]), MONTHS[m[2].toLowerCase()], today),
    },
    {
        re: new RegExp(`${L}(${MONTH_NAMES})\\s+(\\d{1,2})${R}`, 'iu'),
        resolve: (m, today) => fromDayMonth(Number(m[2]), MONTHS[m[1].toLowerCase()], today),
    },
    {
        re: new RegExp(`${L}(\\d{1,2})[./](\\d{1,2})${R}`, 'u'),
        resolve: (m, today) => fromDayMonth(Number(m[1]), Number(m[2]), today),
    },
];
const TAG_RE = /(?<![\p{L}\p{N}])#([\p{L}\p{N}_-]{1,40})/gu;
const ESTIMATE_RE = new RegExp(`${L}~\\s?(\\d{1,3}(?:[.,]\\d)?)\\s*(мин|м|min|m|ч|час[ао]?в?|h|hr)${R}`, 'iu');
export function parseQuickAdd(input, options) {
    const { today } = options;
    let rest = input;
    const matches = [];
    const tags = [];
    rest = rest.replace(TAG_RE, (whole, name) => {
        const tag = name.toLowerCase();
        if (!tags.includes(tag))
            tags.push(tag);
        matches.push({ field: 'tag', text: whole });
        return ' ';
    });
    let estimateMinutes = null;
    const estimate = ESTIMATE_RE.exec(rest);
    if (estimate) {
        const amount = Number(estimate[1].replace(',', '.'));
        const unit = estimate[2].toLowerCase();
        const hours = unit.startsWith('ч') || unit === 'h' || unit === 'hr';
        const minutes = Math.round(hours ? amount * 60 : amount);
        if (minutes > 0 && minutes <= 24 * 60) {
            estimateMinutes = minutes;
            matches.push({ field: 'estimate', text: estimate[0] });
            rest = replaceOnce(rest, estimate[0]);
        }
    }
    // Срок ищется первым: «до 10 сентября» не должно распасться на голую дату.
    const due = findDate(rest, today, true);
    let dueDate = null;
    if (due) {
        dueDate = due.date;
        matches.push({ field: 'dueDate', text: due.text });
        rest = replaceOnce(rest, due.text);
    }
    const scheduled = findDate(rest, today, false);
    let scheduledFor = null;
    if (scheduled) {
        scheduledFor = scheduled.date;
        matches.push({ field: 'scheduledFor', text: scheduled.text });
        rest = replaceOnce(rest, scheduled.text);
    }
    return {
        title: rest.replace(/\s{2,}/gu, ' ').trim(),
        scheduledFor,
        dueDate,
        tags,
        estimateMinutes,
        matches,
    };
}
function findDate(text, today, withDuePrefix) {
    for (const rule of DATE_RULES) {
        const source = withDuePrefix ? DUE_PREFIX + rule.re.source : rule.re.source;
        const re = new RegExp(source, rule.re.flags);
        const m = re.exec(text);
        if (!m)
            continue;
        const date = rule.resolve(m, today);
        if (date)
            return { date, text: m[0] };
    }
    return null;
}
function replaceOnce(text, fragment) {
    const at = text.indexOf(fragment);
    if (at < 0)
        return text;
    return `${text.slice(0, at)} ${text.slice(at + fragment.length)}`;
}
/** Ближайший такой день недели строго после сегодняшнего. */
function nextWeekday(today, weekday) {
    const [y, m, d] = today.split('-').map(Number);
    const current = new Date(Date.UTC(y, m - 1, d)).getUTCDay();
    const ahead = (weekday - current + 7) % 7 || 7;
    return addDays(today, ahead);
}
/** Число и месяц без года: текущий год, а если дата уже прошла — следующий. */
function fromDayMonth(day, month, today) {
    if (month < 1 || month > 12 || day < 1 || day > 31)
        return null;
    const year = Number(today.slice(0, 4));
    const candidate = format(year, month, day);
    if (!candidate)
        return null;
    if (candidate >= today)
        return candidate;
    return format(year + 1, month, day);
}
function format(year, month, day) {
    const date = new Date(Date.UTC(year, month - 1, day));
    if (date.getUTCMonth() !== month - 1 || date.getUTCDate() !== day)
        return null;
    return date.toISOString().slice(0, 10);
}
//# sourceMappingURL=quick-add.js.map